export const leftArrowPixelDot = (
    <svg
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={true}
    >
        <rect x="15" width="2" height="2" fill="currentColor" />
        <rect x="9" y="3" width="2" height="2" fill="currentColor" />
        <rect x="12" y="3" width="2" height="2" fill="currentColor" />
        <rect x="15" y="3" width="2" height="2" fill="currentColor" />
        <rect x="6" y="6" width="2" height="2" fill="currentColor" />
        <rect x="9" y="6" width="2" height="2" fill="currentColor" />
        <rect x="12" y="6" width="2" height="2" fill="currentColor" />
        <rect x="15" y="6" width="2" height="2" fill="currentColor" />
        <rect x="3" y="9" width="2" height="2" fill="currentColor" />
        <rect x="6" y="9" width="2" height="2" fill="currentColor" />
        <rect x="9" y="9" width="2" height="2" fill="currentColor" />
        <rect x="12" y="9" width="2" height="2" fill="currentColor" />
        <rect x="15" y="9" width="2" height="2" fill="currentColor" />
        <rect x="3" y="12" width="2" height="2" fill="currentColor" />
        <rect x="6" y="12" width="2" height="2" fill="currentColor" />
        <rect x="9" y="12" width="2" height="2" fill="currentColor" />
        <rect x="12" y="12" width="2" height="2" fill="currentColor" />
        <rect x="15" y="12" width="2" height="2" fill="currentColor" />
        <rect y="15" width="2" height="2" fill="currentColor" />
        <rect x="3" y="15" width="2" height="2" fill="currentColor" />
        <rect x="6" y="15" width="2" height="2" fill="currentColor" />
        <rect x="9" y="15" width="2" height="2" fill="currentColor" />
        <rect x="12" y="15" width="2" height="2" fill="currentColor" />
        <rect x="21" y="15" width="2" height="2" fill="currentColor" />
        <rect x="15" y="15" width="2" height="2" fill="currentColor" />
        <rect x="24" y="15" width="2" height="2" fill="currentColor" />
        <rect y="18" width="2" height="2" fill="currentColor" />
        <rect x="3" y="18" width="2" height="2" fill="currentColor" />
        <rect x="6" y="18" width="2" height="2" fill="currentColor" />
        <rect x="9" y="18" width="2" height="2" fill="currentColor" />
        <rect x="12" y="18" width="2" height="2" fill="currentColor" />
        <rect x="21" y="18" width="2" height="2" fill="currentColor" />
        <rect x="27" y="18" width="2" height="2" fill="currentColor" />
        <rect x="18" y="18" width="2" height="2" fill="currentColor" />
        <rect x="24" y="18" width="2" height="2" fill="currentColor" />
        <rect x="18" width="2" height="2" fill="currentColor" />
        <rect x="18" y="3" width="2" height="2" fill="currentColor" />
        <rect x="18" y="6" width="2" height="2" fill="currentColor" />
        <rect x="18" y="9" width="2" height="2" fill="currentColor" />
        <rect x="18" y="12" width="2" height="2" fill="currentColor" />
        <rect x="21" y="12" width="2" height="2" fill="currentColor" />
        <rect x="21" width="2" height="2" fill="currentColor" />
        <rect x="24" width="2" height="2" fill="currentColor" />
        <rect x="27" width="2" height="2" fill="currentColor" />
        <rect x="21" y="3" width="2" height="2" fill="currentColor" />
        <rect x="24" y="3" width="2" height="2" fill="currentColor" />
        <rect x="27" y="3" width="2" height="2" fill="currentColor" />
        <rect x="30" y="3" width="2" height="2" fill="currentColor" />
        <rect x="33" y="3" width="2" height="2" fill="currentColor" />
        <rect x="21" y="6" width="2" height="2" fill="currentColor" />
        <rect x="24" y="6" width="2" height="2" fill="currentColor" />
        <rect x="27" y="6" width="2" height="2" fill="currentColor" />
        <rect x="30" y="6" width="2" height="2" fill="currentColor" />
        <rect x="33" y="6" width="2" height="2" fill="currentColor" />
        <rect x="36" y="6" width="2" height="2" fill="currentColor" />
        <rect x="21" y="9" width="2" height="2" fill="currentColor" />
        <rect x="24" y="9" width="2" height="2" fill="currentColor" />
        <rect x="27" y="9" width="2" height="2" fill="currentColor" />
        <rect x="30" y="9" width="2" height="2" fill="currentColor" />
        <rect x="33" y="9" width="2" height="2" fill="currentColor" />
        <rect x="36" y="9" width="2" height="2" fill="currentColor" />
        <rect x="39" y="9" width="2" height="2" fill="currentColor" />
        <rect x="24" y="12" width="2" height="2" fill="currentColor" />
        <rect x="27" y="12" width="2" height="2" fill="currentColor" />
        <rect x="30" y="12" width="2" height="2" fill="currentColor" />
        <rect x="33" y="12" width="2" height="2" fill="currentColor" />
        <rect x="36" y="12" width="2" height="2" fill="currentColor" />
        <rect x="39" y="12" width="2" height="2" fill="currentColor" />
        <rect x="27" y="15" width="2" height="2" fill="currentColor" />
        <rect x="30" y="15" width="2" height="2" fill="currentColor" />
        <rect x="36" y="15" width="2" height="2" fill="currentColor" />
        <rect x="39" y="15" width="2" height="2" fill="currentColor" />
        <rect x="42" y="15" width="2" height="2" fill="currentColor" />
        <rect x="36" y="18" width="2" height="2" fill="currentColor" />
        <rect x="39" y="18" width="2" height="2" fill="currentColor" />
        <rect x="42" y="18" width="2" height="2" fill="currentColor" />
        <rect y="24" width="2" height="2" fill="currentColor" />
        <rect x="3" y="24" width="2" height="2" fill="currentColor" />
        <rect x="6" y="24" width="2" height="2" fill="currentColor" />
        <rect x="9" y="24" width="2" height="2" fill="currentColor" />
        <rect y="21" width="2" height="2" fill="currentColor" />
        <rect x="3" y="21" width="2" height="2" fill="currentColor" />
        <rect x="6" y="21" width="2" height="2" fill="currentColor" />
        <rect x="9" y="21" width="2" height="2" fill="currentColor" />
        <rect y="27" width="2" height="2" fill="currentColor" />
        <rect x="3" y="27" width="2" height="2" fill="currentColor" />
        <rect x="6" y="27" width="2" height="2" fill="currentColor" />
        <rect x="9" y="27" width="2" height="2" fill="currentColor" />
        <rect x="12" y="27" width="2" height="2" fill="currentColor" />
        <rect x="21" y="27" width="2" height="2" fill="currentColor" />
        <rect x="15" y="27" width="2" height="2" fill="currentColor" />
        <rect x="24" y="27" width="2" height="2" fill="currentColor" />
        <rect x="3" y="30" width="2" height="2" fill="currentColor" />
        <rect x="6" y="30" width="2" height="2" fill="currentColor" />
        <rect x="9" y="30" width="2" height="2" fill="currentColor" />
        <rect x="12" y="30" width="2" height="2" fill="currentColor" />
        <rect x="15" y="30" width="2" height="2" fill="currentColor" />
        <rect x="12" y="24" width="2" height="2" fill="currentColor" />
        <rect x="21" y="24" width="2" height="2" fill="currentColor" />
        <rect x="27" y="24" width="2" height="2" fill="currentColor" />
        <rect x="18" y="24" width="2" height="2" fill="currentColor" />
        <rect x="24" y="24" width="2" height="2" fill="currentColor" />
        <rect x="3" y="33" width="2" height="2" fill="currentColor" />
        <rect x="6" y="33" width="2" height="2" fill="currentColor" />
        <rect x="9" y="33" width="2" height="2" fill="currentColor" />
        <rect x="12" y="33" width="2" height="2" fill="currentColor" />
        <rect x="15" y="33" width="2" height="2" fill="currentColor" />
        <rect x="6" y="36" width="2" height="2" fill="currentColor" />
        <rect x="9" y="36" width="2" height="2" fill="currentColor" />
        <rect x="12" y="36" width="2" height="2" fill="currentColor" />
        <rect x="15" y="36" width="2" height="2" fill="currentColor" />
        <rect x="9" y="39" width="2" height="2" fill="currentColor" />
        <rect x="12" y="39" width="2" height="2" fill="currentColor" />
        <rect x="15" y="39" width="2" height="2" fill="currentColor" />
        <rect x="15" y="42" width="2" height="2" fill="currentColor" />
        <rect x="18" y="33" width="2" height="2" fill="currentColor" />
        <rect x="18" y="30" width="2" height="2" fill="currentColor" />
        <rect x="18" y="36" width="2" height="2" fill="currentColor" />
        <rect x="21" y="30" width="2" height="2" fill="currentColor" />
        <rect x="18" y="39" width="2" height="2" fill="currentColor" />
        <rect x="18" y="42" width="2" height="2" fill="currentColor" />
        <rect x="30" y="24" width="2" height="2" fill="currentColor" />
        <rect x="30" y="18" width="2" height="2" fill="currentColor" />
        <rect x="33" y="24" width="2" height="2" fill="currentColor" />
        <rect x="33" y="18" width="2" height="2" fill="currentColor" />
        <rect x="36" y="24" width="2" height="2" fill="currentColor" />
        <rect x="39" y="24" width="2" height="2" fill="currentColor" />
        <rect x="42" y="24" width="2" height="2" fill="currentColor" />
        <rect x="33" y="21" width="2" height="2" fill="currentColor" />
        <rect x="33" y="15" width="2" height="2" fill="currentColor" />
        <rect x="36" y="21" width="2" height="2" fill="currentColor" />
        <rect x="39" y="21" width="2" height="2" fill="currentColor" />
        <rect x="42" y="21" width="2" height="2" fill="currentColor" />
        <rect x="27" y="27" width="2" height="2" fill="currentColor" />
        <rect x="30" y="27" width="2" height="2" fill="currentColor" />
        <rect x="33" y="27" width="2" height="2" fill="currentColor" />
        <rect x="36" y="27" width="2" height="2" fill="currentColor" />
        <rect x="39" y="27" width="2" height="2" fill="currentColor" />
        <rect x="42" y="27" width="2" height="2" fill="currentColor" />
        <rect x="24" y="30" width="2" height="2" fill="currentColor" />
        <rect x="27" y="30" width="2" height="2" fill="currentColor" />
        <rect x="30" y="30" width="2" height="2" fill="currentColor" />
        <rect x="33" y="30" width="2" height="2" fill="currentColor" />
        <rect x="36" y="30" width="2" height="2" fill="currentColor" />
        <rect x="39" y="30" width="2" height="2" fill="currentColor" />
        <rect x="21" y="33" width="2" height="2" fill="currentColor" />
        <rect x="24" y="33" width="2" height="2" fill="currentColor" />
        <rect x="27" y="33" width="2" height="2" fill="currentColor" />
        <rect x="30" y="33" width="2" height="2" fill="currentColor" />
        <rect x="33" y="33" width="2" height="2" fill="currentColor" />
        <rect x="36" y="33" width="2" height="2" fill="currentColor" />
        <rect x="39" y="33" width="2" height="2" fill="currentColor" />
        <rect x="21" y="36" width="2" height="2" fill="currentColor" />
        <rect x="24" y="36" width="2" height="2" fill="currentColor" />
        <rect x="27" y="36" width="2" height="2" fill="currentColor" />
        <rect x="30" y="36" width="2" height="2" fill="currentColor" />
        <rect x="33" y="36" width="2" height="2" fill="currentColor" />
        <rect x="36" y="36" width="2" height="2" fill="currentColor" />
        <rect x="21" y="39" width="2" height="2" fill="currentColor" />
        <rect x="24" y="39" width="2" height="2" fill="currentColor" />
        <rect x="27" y="39" width="2" height="2" fill="currentColor" />
        <rect x="30" y="39" width="2" height="2" fill="currentColor" />
        <rect x="33" y="39" width="2" height="2" fill="currentColor" />
        <rect x="21" y="42" width="2" height="2" fill="currentColor" />
        <rect x="24" y="42" width="2" height="2" fill="currentColor" />
        <rect x="27" y="42" width="2" height="2" fill="currentColor" />
    </svg>
);

export const rightArrowPixelDot = (
    <svg
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={true}
    >
        <rect x="15" width="2" height="2" fill="currentColor" />
        <rect x="9" y="3" width="2" height="2" fill="currentColor" />
        <rect x="12" y="3" width="2" height="2" fill="currentColor" />
        <rect x="15" y="3" width="2" height="2" fill="currentColor" />
        <rect x="6" y="6" width="2" height="2" fill="currentColor" />
        <rect x="9" y="6" width="2" height="2" fill="currentColor" />
        <rect x="12" y="6" width="2" height="2" fill="currentColor" />
        <rect x="15" y="6" width="2" height="2" fill="currentColor" />
        <rect x="3" y="9" width="2" height="2" fill="currentColor" />
        <rect x="6" y="9" width="2" height="2" fill="currentColor" />
        <rect x="9" y="9" width="2" height="2" fill="currentColor" />
        <rect x="12" y="9" width="2" height="2" fill="currentColor" />
        <rect x="15" y="9" width="2" height="2" fill="currentColor" />
        <rect x="3" y="12" width="2" height="2" fill="currentColor" />
        <rect x="6" y="12" width="2" height="2" fill="currentColor" />
        <rect x="9" y="12" width="2" height="2" fill="currentColor" />
        <rect x="12" y="12" width="2" height="2" fill="currentColor" />
        <rect x="15" y="12" width="2" height="2" fill="currentColor" />
        <rect y="15" width="2" height="2" fill="currentColor" />
        <rect x="3" y="15" width="2" height="2" fill="currentColor" />
        <rect x="6" y="15" width="2" height="2" fill="currentColor" />
        <rect x="9" y="15" width="2" height="2" fill="currentColor" />
        <rect x="12" y="15" width="2" height="2" fill="currentColor" />
        <rect x="18" y="15" width="2" height="2" fill="currentColor" />
        <rect x="15" y="15" width="2" height="2" fill="currentColor" />
        <rect x="21" y="15" width="2" height="2" fill="currentColor" />
        <rect y="18" width="2" height="2" fill="currentColor" />
        <rect x="3" y="18" width="2" height="2" fill="currentColor" />
        <rect x="6" y="18" width="2" height="2" fill="currentColor" />
        <rect x="9" y="18" width="2" height="2" fill="currentColor" />
        <rect x="12" y="18" width="2" height="2" fill="currentColor" />
        <rect x="18" y="18" width="2" height="2" fill="currentColor" />
        <rect x="24" y="18" width="2" height="2" fill="currentColor" />
        <rect x="15" y="18" width="2" height="2" fill="currentColor" />
        <rect x="21" y="18" width="2" height="2" fill="currentColor" />
        <rect x="18" width="2" height="2" fill="currentColor" />
        <rect x="18" y="3" width="2" height="2" fill="currentColor" />
        <rect x="18" y="6" width="2" height="2" fill="currentColor" />
        <rect x="18" y="9" width="2" height="2" fill="currentColor" />
        <rect x="18" y="12" width="2" height="2" fill="currentColor" />
        <rect x="21" y="12" width="2" height="2" fill="currentColor" />
        <rect x="21" width="2" height="2" fill="currentColor" />
        <rect x="24" width="2" height="2" fill="currentColor" />
        <rect x="27" width="2" height="2" fill="currentColor" />
        <rect x="21" y="3" width="2" height="2" fill="currentColor" />
        <rect x="24" y="3" width="2" height="2" fill="currentColor" />
        <rect x="27" y="3" width="2" height="2" fill="currentColor" />
        <rect x="30" y="3" width="2" height="2" fill="currentColor" />
        <rect x="33" y="3" width="2" height="2" fill="currentColor" />
        <rect x="21" y="6" width="2" height="2" fill="currentColor" />
        <rect x="24" y="6" width="2" height="2" fill="currentColor" />
        <rect x="27" y="6" width="2" height="2" fill="currentColor" />
        <rect x="30" y="6" width="2" height="2" fill="currentColor" />
        <rect x="33" y="6" width="2" height="2" fill="currentColor" />
        <rect x="36" y="6" width="2" height="2" fill="currentColor" />
        <rect x="21" y="9" width="2" height="2" fill="currentColor" />
        <rect x="24" y="9" width="2" height="2" fill="currentColor" />
        <rect x="27" y="9" width="2" height="2" fill="currentColor" />
        <rect x="30" y="9" width="2" height="2" fill="currentColor" />
        <rect x="33" y="9" width="2" height="2" fill="currentColor" />
        <rect x="36" y="9" width="2" height="2" fill="currentColor" />
        <rect x="39" y="9" width="2" height="2" fill="currentColor" />
        <rect x="24" y="12" width="2" height="2" fill="currentColor" />
        <rect x="27" y="12" width="2" height="2" fill="currentColor" />
        <rect x="30" y="12" width="2" height="2" fill="currentColor" />
        <rect x="33" y="12" width="2" height="2" fill="currentColor" />
        <rect x="36" y="12" width="2" height="2" fill="currentColor" />
        <rect x="39" y="12" width="2" height="2" fill="currentColor" />
        <rect x="27" y="15" width="2" height="2" fill="currentColor" />
        <rect x="30" y="15" width="2" height="2" fill="currentColor" />
        <rect x="36" y="15" width="2" height="2" fill="currentColor" />
        <rect x="39" y="15" width="2" height="2" fill="currentColor" />
        <rect x="42" y="15" width="2" height="2" fill="currentColor" />
        <rect x="36" y="18" width="2" height="2" fill="currentColor" />
        <rect x="39" y="18" width="2" height="2" fill="currentColor" />
        <rect x="42" y="18" width="2" height="2" fill="currentColor" />
        <rect y="24" width="2" height="2" fill="currentColor" />
        <rect x="3" y="24" width="2" height="2" fill="currentColor" />
        <rect x="6" y="24" width="2" height="2" fill="currentColor" />
        <rect x="9" y="24" width="2" height="2" fill="currentColor" />
        <rect y="21" width="2" height="2" fill="currentColor" />
        <rect x="3" y="21" width="2" height="2" fill="currentColor" />
        <rect x="6" y="21" width="2" height="2" fill="currentColor" />
        <rect x="9" y="21" width="2" height="2" fill="currentColor" />
        <rect y="27" width="2" height="2" fill="currentColor" />
        <rect x="3" y="27" width="2" height="2" fill="currentColor" />
        <rect x="6" y="27" width="2" height="2" fill="currentColor" />
        <rect x="9" y="27" width="2" height="2" fill="currentColor" />
        <rect x="12" y="27" width="2" height="2" fill="currentColor" />
        <rect x="18" y="27" width="2" height="2" fill="currentColor" />
        <rect x="15" y="27" width="2" height="2" fill="currentColor" />
        <rect x="21" y="27" width="2" height="2" fill="currentColor" />
        <rect x="3" y="30" width="2" height="2" fill="currentColor" />
        <rect x="6" y="30" width="2" height="2" fill="currentColor" />
        <rect x="9" y="30" width="2" height="2" fill="currentColor" />
        <rect x="12" y="30" width="2" height="2" fill="currentColor" />
        <rect x="15" y="30" width="2" height="2" fill="currentColor" />
        <rect x="12" y="24" width="2" height="2" fill="currentColor" />
        <rect x="18" y="24" width="2" height="2" fill="currentColor" />
        <rect x="24" y="24" width="2" height="2" fill="currentColor" />
        <rect x="15" y="24" width="2" height="2" fill="currentColor" />
        <rect x="21" y="24" width="2" height="2" fill="currentColor" />
        <rect x="3" y="33" width="2" height="2" fill="currentColor" />
        <rect x="6" y="33" width="2" height="2" fill="currentColor" />
        <rect x="9" y="33" width="2" height="2" fill="currentColor" />
        <rect x="12" y="33" width="2" height="2" fill="currentColor" />
        <rect x="15" y="33" width="2" height="2" fill="currentColor" />
        <rect x="6" y="36" width="2" height="2" fill="currentColor" />
        <rect x="9" y="36" width="2" height="2" fill="currentColor" />
        <rect x="12" y="36" width="2" height="2" fill="currentColor" />
        <rect x="15" y="36" width="2" height="2" fill="currentColor" />
        <rect x="9" y="39" width="2" height="2" fill="currentColor" />
        <rect x="12" y="39" width="2" height="2" fill="currentColor" />
        <rect x="15" y="39" width="2" height="2" fill="currentColor" />
        <rect x="15" y="42" width="2" height="2" fill="currentColor" />
        <rect x="18" y="33" width="2" height="2" fill="currentColor" />
        <rect x="18" y="30" width="2" height="2" fill="currentColor" />
        <rect x="18" y="36" width="2" height="2" fill="currentColor" />
        <rect x="21" y="30" width="2" height="2" fill="currentColor" />
        <rect x="18" y="39" width="2" height="2" fill="currentColor" />
        <rect x="18" y="42" width="2" height="2" fill="currentColor" />
        <rect x="30" y="24" width="2" height="2" fill="currentColor" />
        <rect x="30" y="18" width="2" height="2" fill="currentColor" />
        <rect x="33" y="24" width="2" height="2" fill="currentColor" />
        <rect x="33" y="18" width="2" height="2" fill="currentColor" />
        <rect x="36" y="24" width="2" height="2" fill="currentColor" />
        <rect x="39" y="24" width="2" height="2" fill="currentColor" />
        <rect x="42" y="24" width="2" height="2" fill="currentColor" />
        <rect x="33" y="21" width="2" height="2" fill="currentColor" />
        <rect x="33" y="15" width="2" height="2" fill="currentColor" />
        <rect x="36" y="21" width="2" height="2" fill="currentColor" />
        <rect x="39" y="21" width="2" height="2" fill="currentColor" />
        <rect x="42" y="21" width="2" height="2" fill="currentColor" />
        <rect x="27" y="27" width="2" height="2" fill="currentColor" />
        <rect x="30" y="27" width="2" height="2" fill="currentColor" />
        <rect x="33" y="27" width="2" height="2" fill="currentColor" />
        <rect x="36" y="27" width="2" height="2" fill="currentColor" />
        <rect x="39" y="27" width="2" height="2" fill="currentColor" />
        <rect x="42" y="27" width="2" height="2" fill="currentColor" />
        <rect x="24" y="30" width="2" height="2" fill="currentColor" />
        <rect x="27" y="30" width="2" height="2" fill="currentColor" />
        <rect x="30" y="30" width="2" height="2" fill="currentColor" />
        <rect x="33" y="30" width="2" height="2" fill="currentColor" />
        <rect x="36" y="30" width="2" height="2" fill="currentColor" />
        <rect x="39" y="30" width="2" height="2" fill="currentColor" />
        <rect x="21" y="33" width="2" height="2" fill="currentColor" />
        <rect x="24" y="33" width="2" height="2" fill="currentColor" />
        <rect x="27" y="33" width="2" height="2" fill="currentColor" />
        <rect x="30" y="33" width="2" height="2" fill="currentColor" />
        <rect x="33" y="33" width="2" height="2" fill="currentColor" />
        <rect x="36" y="33" width="2" height="2" fill="currentColor" />
        <rect x="39" y="33" width="2" height="2" fill="currentColor" />
        <rect x="21" y="36" width="2" height="2" fill="currentColor" />
        <rect x="24" y="36" width="2" height="2" fill="currentColor" />
        <rect x="27" y="36" width="2" height="2" fill="currentColor" />
        <rect x="30" y="36" width="2" height="2" fill="currentColor" />
        <rect x="33" y="36" width="2" height="2" fill="currentColor" />
        <rect x="36" y="36" width="2" height="2" fill="currentColor" />
        <rect x="21" y="39" width="2" height="2" fill="currentColor" />
        <rect x="24" y="39" width="2" height="2" fill="currentColor" />
        <rect x="27" y="39" width="2" height="2" fill="currentColor" />
        <rect x="30" y="39" width="2" height="2" fill="currentColor" />
        <rect x="33" y="39" width="2" height="2" fill="currentColor" />
        <rect x="21" y="42" width="2" height="2" fill="currentColor" />
        <rect x="24" y="42" width="2" height="2" fill="currentColor" />
        <rect x="27" y="42" width="2" height="2" fill="currentColor" />
    </svg>
);
